<script setup>
import useAdbutlerChecker from "../../composables/useAdbutlerChecker";

const { showAdButlerBanner, hideBanner } = useAdbutlerChecker();
const router = useRoute();

defineProps(["id"]);
</script>

<template>
	<!-- <Transition> -->
	<div id="adbutler-container"></div>

	<AizenBannerAd
		v-if="showAdButlerBanner && !router.fullPath.includes('news')"
		:has-sidebar="store.contentSidebar.show"
		@close="hideBanner"
	/>
	<!-- </Transition> -->

	<Row
		:id="id"
		:is-news="router.fullPath.includes('news')"
		:class="{ '!bg-white': router.name === 'news-slug' }"
	>
		<slot />

		<div
			class="blog-container xl:container w-full xl:flex xl:gap-[80px]"
			:class="{
				'has-sidebar': store.contentSidebar.show
			}"
		>
			<div class="columns w-full xl:max-w-[912px]">
				<slot name="main" />
			</div>
			<div
				id="ts-sidebar"
				class="mt-[32px] block xl:mt-0 w-full ml-auto mr-auto xl:mr-0"
				:class="
					router.fullPath.includes('news')
						? 'px-[16px] md:px-0 md:max-w-[412px] p-4 rounded-[24px] bg-[#eff6ff]'
						: 'md:max-w-[380px]'
				"
			>
				<slot name="aside" />
			</div>
		</div>
	</Row>
</template>

<style lang="scss" scoped>
.xl\:mt-0 {
	margin-top: 32px;
}
@media (min-width: 1360px) {
	.xl\:mt-0 {
		margin-top: 0px;
	}
}
.xl\:mr-0 {
	margin-right: auto;
}

.xl\:flex {
	display: block;
}
@media (min-width: 1360px) {
	.xl\:mr-0 {
		margin-right: 0px;
	}

	.xl\:flex {
		display: flex;
	}
}
</style>
